import { nanoid } from 'nanoid'
import type {
  ElementId, TypeId, AssemblyId, MaterialId, LevelId, PhaseId, ViewId, SheetId, NodeId, DraftingId,
  AnnoTypeId, GridId, SiteId, DownspoutId, TapeNoteId, RoomId, RoomSeparatorId, DraftLayerId, PhaseSplitId, CircuitId,
} from './types'

// 12-char nanoid: ~2M years to 1% collision at 1000 ids/hour — plenty for per-doc ids.
const mint = () => nanoid(12)

export const newElementId = () => mint() as ElementId
export const newTypeId = () => mint() as TypeId
export const newAssemblyId = () => mint() as AssemblyId
export const newMaterialId = () => mint() as MaterialId
export const newLevelId = () => mint() as LevelId
export const newPhaseId = () => mint() as PhaseId
export const newViewId = () => mint() as ViewId
export const newSheetId = () => mint() as SheetId
export const newNodeId = () => mint() as NodeId
export const newDraftingId = () => mint() as DraftingId
export const newAnnoTypeId = () => mint() as AnnoTypeId
export const newGridId = () => mint() as GridId
export const newSiteId = () => mint() as SiteId
export const newDownspoutId = () => mint() as DownspoutId
/** DATUM UX round: grid HEAD-LOCK alignment-group ids (plain strings, shared across the group) */
export const newHeadLockId = () => mint()
export const newTapeNoteId = () => mint() as TapeNoteId
export const newRoomId = () => mint() as RoomId
export const newRoomSeparatorId = () => mint() as RoomSeparatorId
export const newDraftLayerId = () => mint() as DraftLayerId
export const newCircuitId = () => mint() as CircuitId
export const newPhaseSplitId = () => mint() as PhaseSplitId
